import styles from "../styles/components/Load.module.css";

export function Load() {
  return (
    <div className={styles.ContainerLoad}>
      <div className={styles.Load}></div>
    </div>
  );
}
